module.exports = __webpack_public_path__ + "img/bg-2.2121d24c.jpg";